import { useGraphqlPagination } from '@components/infiniteScroll';
import { GetInpaintsQuery, Inpaint, useGetInpaintsQuery } from '@generated/graphql';
import { PropsWithChildren, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { BehaviorSubject } from 'rxjs';

type InpaintProviderType = {
  data: Inpaint[];
  fetchMore: VoidFunction;
  loading: boolean;
  refetch: VoidFunction;
  open$: BehaviorSubject<boolean>;
};

type VolumeInpaintModalProviderProps = {
  volumeId: string;
};

export const VolumeInpaintContext = createContext<InpaintProviderType>({} as InpaintProviderType);
export const VolumeInpaintProvider = ({
  volumeId,
  children,
}: PropsWithChildren<VolumeInpaintModalProviderProps>) => {
  const [open$] = useState(new BehaviorSubject<boolean>(false));

  const pagination = useGraphqlPagination<GetInpaintsQuery, Inpaint>(
    useGetInpaintsQuery({
      variables: { volumeId, limit: 30 },
    }),
    'getInpaints',
    'inpaintId',
    { pollInterval: 10000 },
  );

  useEffect(() => {
    if (
      pagination?.data.some((inpaint) => ['queued', 'starting', 'running'].includes(inpaint.status))
    ) {
      pagination?.setPollInterval(5000);
    } else {
      pagination?.setPollInterval(10000);
    }
  }, [pagination?.data]);

  const value = useMemo(() => ({ ...pagination, open$ }), [pagination, open$]);
  return <VolumeInpaintContext.Provider value={value}>{children}</VolumeInpaintContext.Provider>;
};

export const useInpaintModal = () => useContext(VolumeInpaintContext);
